import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from "@material-ui/core/MenuItem";

const SortStoresForm =  (props) => {
  return (
    <form>
      <div className={'form-row'}>
        <div className={'form-group col-7'}>
          <Field name="sortBy" label={'Sort By'} component={RenderSelectField} fullWidth>
            <MenuItem value={'id'} >{'Id'}</MenuItem>
            <MenuItem value={'name'} >{'Name'}</MenuItem>
            <MenuItem value={'dwId'} >{'Erp Id'}</MenuItem>
            <MenuItem value={'city'} >{'City'}</MenuItem>
            <MenuItem value={'enterSoftCode'} >{'Entersoft code'}</MenuItem>
            <MenuItem value={'type'} >{'Type'}</MenuItem>
            <MenuItem value={'openDate'} >{'Open Date'}</MenuItem>
            <MenuItem value={'createdDate'} >{'Created Date'}</MenuItem>
          </Field>
        </div>
        <div className={'form-group col-5'}>
          <Field name={'sortOrder'} label={'Sort order'} component={RenderSelectField} fullWidth>
            <MenuItem value={'asc'}>{'ASC'}</MenuItem>
            <MenuItem value={'desc'}>{'DESC'}</MenuItem>
          </Field>
        </div>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'sortStoresForm',
})(SortStoresForm);



// WEBPACK FOOTER //
// ./src/components/stores/sortStoresForm.js